import React from "react";
import { FormattedMessage } from "react-intl";
import { Blockquote } from "@wfp/ui";

import ConfirmationModal from "components/ConfirmationModal";
import LevelTitle from "components/LevelTitle";
import { studentKinds, AttendanceShift } from "SCConstants";

import "./_enrolment-warning-modal.scss";

export type OverEnrolmentEntry = {
  level: string;
  shift: AttendanceShift;
  kind: "male" | "female";
  value: number;
  max: number;
};

type EnrolmentWarningModalProps = {
  open: boolean;
  overEntries: OverEnrolmentEntry[];
  showShift?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const ShiftLabel = ({ shift }: { shift: AttendanceShift }) =>
  shift === "afternoon" ? (
    <FormattedMessage
      id="AttendanceShow.afternoon"
      defaultMessage="Afternoon"
    />
  ) : (
    <FormattedMessage id="AttendanceShow.morning" defaultMessage="Morning" />
  );

const EnrolmentWarningModal: React.ComponentType<EnrolmentWarningModalProps> = ({
  open,
  overEntries,
  showShift,
  onConfirm,
  onCancel,
}) => {
  const message = (
    <>
      <Blockquote kind="warning">
        <p>
          <FormattedMessage
            id="EnrolmentWarning.intro"
            defaultMessage="Some entries are higher than the recorded enrolment. Please double check the numbers below before saving."
          />
        </p>
      </Blockquote>
      <ul className="enrolment-warning-list">
        {overEntries.map((entry, i) => {
          const kind = studentKinds.find((k) => k.value === entry.kind);
          return (
            <li key={i}>
              <LevelTitle level={{ level: entry.level }} /> {"- "}
              {kind?.labelTrans}
              {showShift && (
                <>
                  {" ("}
                  <ShiftLabel shift={entry.shift} />
                  {")"}
                </>
              )}
              {": "}
              <FormattedMessage
                id="EnrolmentWarning.entry"
                defaultMessage="{value} entered, {max} enrolled"
                values={{ value: entry.value, max: entry.max }}
              />
            </li>
          );
        })}
      </ul>
    </>
  );

  return (
    <ConfirmationModal
      confirmationModalState={open}
      modalType="submit"
      setConfirmationModalState={(value: boolean) => {
        if (!value) onCancel();
      }}
      onConfirmationModalSubmit={onConfirm}
      submitMessage={message}
    />
  );
};

export default EnrolmentWarningModal;
